import { pluralizeStepType } from "shared/lib/utils"

import { CreditsBalance } from "shared/utils/credits"

import { CreditCosts, DIYComposerState, PublicTQAShape, Service, StepType, TQAType } from "./interfaces"

export type StateWithCredits = DIYComposerState & { creditsBalance: CreditsBalance; creditCosts: CreditCosts }

export const creditsLoaded = (state: DIYComposerState): state is StateWithCredits =>
  !!state.creditsBalance && !!state.creditCosts

export const spentPercentage = ({ spent, monthly_total }: CreditsBalance): number =>
  monthly_total > 0 ? Math.min(100, Math.max(0, Math.round((spent / monthly_total) * 100))) : 0

// A step's cost lives on the catalog entry rather than on the step the composer stores, because
// only the catalog is loaded on every path into the builder (fresh pick, edit, template, chat).
export const stepCredits = (services: Array<Service>, step: TQAType | undefined, type: StepType): number => {
  if (!step) return 0

  const service = services.find(s => s.id === (step.service?.id ?? step.channel?.id))
  const catalogStep = service?.[`public_${pluralizeStepType(type)}`]?.find(
    (tqa: PublicTQAShape) => tqa.full_module_name === step.full_module_name,
  )

  return catalogStep?.credits ?? step.credits ?? 0
}

export const creditLabel = (credits: number): string => `${credits} ${credits === 1 ? "credit" : "credits"}`
